export default {
  title: "My Work",
  subtitle: "My life at work",
  description: "A large part of your waking hours are spent at work. Then it's important to feel good and be well.",
  startButton: "Get started",
  results: "Results",
  goodJob: "Good job, see the results!",
  clickPieSlice: "Click on a pie slice to see more information about your result.",
  healthyMessage: "You are on the right track to feel good in the future. Keep building on it!",
  riskMessage: "Watch out for upcoming illness.",
  
  // Work factor labels (fallback translations for database labels)
  factorLabels: {
    'Arbetsmiljö': 'Work Environment',
    'Meningsfullhet': 'Meaningfulness',
    'Trivsel': 'Well-being',
    'Arbetsuppgifter': 'Work Tasks',
    'Förståelighet': 'Comprehensibility',
    'Hanterbarhet': 'Manageability',
    'Kompetens': 'Competence',
    'Inflytande': 'Influence',
    'Stress på arbete': 'Work Stress',
    'Samarbete': 'Cooperation',
    'Ambitioner': 'Ambitions',
    'Uppskattad': 'Appreciation',
    'Samarbete chef': 'Manager Cooperation',
    'Utveckling': 'Development',
    'Mål (arbetsorganisation)': 'Goals (Work Organization)',
    'Trygghet (säkerhet och hälsa)': 'Safety (Security and Health)',
    'Lugn arbetsmiljö': 'Calm Work Environment',
    'Begriplighet': 'Comprehensibility',
    'Trygghet': 'Safety',
    'Mål': 'Goals',
  },
  // Add any other work-related translations that might be needed
}; 